import { axios } from '@core/axios';
import { Profile } from '@model/profile';
import { DIPOBackBaseResponse } from '@model/response/@base-response/dipo-back-base-response';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class ProfileService {
  private static baseUrl = '/user';
  public static getProfile(): Observable<Profile> {
    const url = `${this.baseUrl}`;
    return from(axios.get<DIPOBackBaseResponse<Profile>>(url)).pipe(map(({ data }) => data.data[0]));
  }
  public static getChangePassword(jwt: string): Observable<boolean> {
    const url = `${this.baseUrl}/change-password`;
    return from(
      axios.get<DIPOBackBaseResponse<boolean>>(url, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        },
      })
    ).pipe(map(({ data }) => data.data[0]));
  }
}
